// extracted by mini-css-extract-plugin
export default {"wrapper":"ToolTip_wrapper__KdFJw","tooltip":"ToolTip_tooltip__Vz21+"};